<script setup>
import { nextTick, ref, watch } from 'vue';
const props = defineProps({ open: Boolean, preflight: { type: Object, required: true } });
const emit = defineEmits(['close', 'resolve']);
const dialog = ref(null);
watch(() => props.open, async (open) => {
  await nextTick();
  if (open && !dialog.value.open) dialog.value.showModal();
  if (!open && dialog.value.open) dialog.value.close();
});
</script>

<template>
  <dialog ref="dialog" aria-labelledby="export-blockers-title" class="w-[min(64rem,95vw)] max-h-[85vh] overflow-y-auto rounded-xl border border-slate-300 bg-white p-5 text-slate-900 shadow-xl backdrop:bg-black/50 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100" @close="emit('close')">
    <h2 id="export-blockers-title" class="text-lg font-bold">Accountant export blockers ({{ preflight.blocking_count || 0 }})</h2>
    <p class="my-2 text-sm">Approved claims can still be missing required payroll data. Open each item to correct it; no pay values are changed by this list.</p>
    <ul class="mb-4 list-disc pl-5 text-sm"><li v-for="error in preflight.errors" :key="error">{{ error }}</li></ul>
    <section v-for="item in preflight.blockers || []" :key="`${item.type}-${item.id}`" class="mb-3 rounded border border-amber-300 p-3 text-sm dark:border-amber-700">
      <div class="flex flex-wrap items-center justify-between gap-2">
        <h3 class="font-semibold">{{ item.type }} #{{ item.id }} · {{ item.staff || item.file || 'Unmatched staff' }} · {{ item.status }}</h3>
        <button type="button" class="rounded bg-sky-700 px-3 py-1.5 font-semibold text-white" @click="emit('resolve', item)">{{ item.type === 'claim' ? 'Correct claim' : item.type === 'import' ? 'Review import' : 'View document' }}</button>
      </div>
      <p v-if="item.file && item.staff">{{ item.file }}</p>
      <p v-if="item.date || item.reference">{{ item.date || 'Date not matched' }} · {{ item.reference || 'Job not matched' }}</p>
      <p v-if="item.claimed_value">Claimed: {{ item.claimed_value }} · Accepted: {{ item.accepted_value }}</p>
      <ul class="mt-2 list-disc pl-5"><li v-for="issue in item.issues" :key="issue" class="whitespace-pre-line">{{ issue }}</li></ul>
    </section>
    <p v-if="!preflight.blockers?.length" class="my-3 text-sm">No individual blocker details are available. Refresh the payroll run to load the latest export check.</p>
    <div class="flex justify-end"><button type="button" autofocus class="rounded border border-slate-400 px-4 py-2" @click="dialog.close()">Close</button></div>
  </dialog>
</template>
